import React from 'react';
import './EventPage.css';

import { PageTitle } from '../../../components';
import { events } from '../../../constants';
import { getTeamLogo } from '../../../utils';

import { FaArrowRight, FaTicketAlt } from 'react-icons/fa';

import { Link } from 'react-router-dom';


 
const EventPage = () => {

  return ( 
    <>
      {/* Page Title */}
      <PageTitle title={'Upcoming Events'} page={'Upcoming Events'} />

      {/* Section for upcoming events */}
      <section className='upcoming-events'>

        <div className='box-container'>

          {/* Mapping through events array */}
          {events.map((event) => {
            return( 
              <div className='event-item' key={event.id}>
                {/* Link to individual event page */}
                <Link  
                  to={{
                    pathname: '/Events/' + event.teamA+'-Vs-'+event.teamB,
                  }}
                  state={event}
                  className='fixture-event'>

                    {/* Team-1 Logo and Name */}
                    <div className='team-logo'>
                      <img src={getTeamLogo(event.teamA)} alt='Event' /> {/* Team-1 Logo */}
                      <h3>{event.teamA}</h3> {/* Team-1 Name */}
                    </div>

                    {/* Event content */}
                    <div className='fixture-content'>
                      <div className='venue'>{event.details.league}</div> {/* Event Venue */}
                      <div className='time'>{event.details.date} - {event.details.time}</div> {/* Event Date and Time */}
                      <div className='venue'>{event.details.venue}</div> {/* Event Venue */}
                    </div>

                    {/* Team 2 Logo and Name */}
                    <div className='team-logo'>
                      <img src={getTeamLogo(event.teamB)} alt='Event' /> {/* Team-2 Logo */}
                      <h3>{event.teamB}</h3> {/* Team-2 Name */}
                    </div>

                </Link>

                {/* Actions for the event */}
                <div className='action'>
                  <a href="/#" className='btn'>ticket <FaTicketAlt /></a> {/* Link for purchasing tickets */}
                  <Link
                  className='btn'
                    to={{
                      pathname: '/Events/' + event.teamA+'-Vs-'+event.teamB,
                    }}
                    state={event}>report <FaArrowRight /> {/* Link to individual event page */}
                  </Link>
                </div>
              </div>
            )
          })}

        </div>

      </section> 
    </> 
  );
}

export default EventPage;
